<template>
  <div
    class="contact-container"
    :style="{ backgroundImage: patternIizenglish }"
  >
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <section class="container contact-forms">
      <h1 class="title">{{ $t(`contactUs.title`) }}</h1>
      <div class="accordion accordion-flush" id="forms-accordion">
        <!-- collapse one -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="heading-one">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              {{ $t(`contactUs.forms.student`) }}
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="heading-one"
            data-bs-parent="#forms-accordion"
          >
            <div class="accordion-body">
              <ContactForm originForm="student" />
            </div>
          </div>
        </div>
        <!-- collapse two -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="heading-two">
            <button
              class="accordion-button collapsed accordion-blue"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ $t(`contactUs.forms.teacher`) }}
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#forms-accordion"
          >
            <div class="accordion-body">
              <ContactForm originForm="teacher" />
            </div>
          </div>
        </div>
        <!-- collapse three -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="heading-three">
            <button
              class="accordion-button collapsed accordion-blue"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              {{ $t(`contactUs.forms.other`) }}
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#forms-accordion"
          >
            <div class="accordion-body">
              <ContactForm originForm="other" />
            </div>
          </div>
        </div>
      </div>
      <!-- FAQ -->
    </section>
    <section class="faq">
      <DecoratedSubtitle title="FAQ" id="faq-title" />
      <div class="container">
        <div class="accordion accordion-flush" id="faq-accordion">
          <!-- collapse one -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq-heading-one">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faqCollapseOne"
                aria-expanded="false"
                aria-controls="faqCollapseOne"
              >
                {{ $t(`contactUs.faq.sections.password.q`) }}
              </button>
            </h2>
            <div
              id="faqCollapseOne"
              class="accordion-collapse collapse"
              aria-labelledby="faq-heading-one"
              data-bs-parent="#faq-accordion"
            >
              <div class="accordion-body">
                <p>
                  {{ $t(`contactUs.faq.sections.password.a`) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PatternIizenglishHomeMultisupport from "@/assets/homepage/pattern-iizenglish-home-multisupport.webp";
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";
import DecoratedSubtitle from "@/components/staticpages/DecoratedSubtitle";
import ContactForm from "@/components/staticpages/ContactForm";

export default {
  name: "ContactUs",
  components: {
    StaticPagesHeader,
    DecoratedSubtitle,
    ContactForm,
  },
  data() {
    return {
      patternIizenglish: `url(${PatternIizenglishHomeMultisupport})`,
    };
  },
};
</script>

<style scoped lang="scss">
.accordion-button:after {
  background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") !important;
}

.contact-container {
  min-height: 93vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: $whiteColor;
  box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, 0.8);

  .contact-forms {
    #forms-accordion {
      .accordion-button {
        background-color: $primaryColor;
        color: $whiteColor;
      }
    }
    .title {
      text-align: center;
      font-family: "Averia Sans Libre", sans-serif;
      font-size: 3em;
      color: $primaryColor;
      margin: 40px 0 40px 0px;
    }
  }

  .faq {
    padding-bottom: 3em;
    #faq-title {
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
    #faq-accordion {
      .accordion-button {
        background-color: $secondaryColor;
        color: $whiteColor;
      }
    }
  }
}
</style>
